import React, { useEffect, useState, useRef } from 'react';
import Config from '../../../config/Config';

const IframeLoader = (props) => {

    const [isPlaying, setIsPlaying] = useState(false)
    const iframeRef = useRef();

    const playPauseAudio = (e) => {
        e.preventDefault()
        if (isPlaying) {
            setIsPlaying(false)
        } else {
            setIsPlaying(true)
        }
    }

    return (
        <>
            <div className={`iframeLoaderCard ${isPlaying ? 'active' : ''}`}>
                <button onClick={playPauseAudio}>
                    <i className="fa fa-times-circle" aria-hidden="true"></i>
                </button>
                <iframe
                    src={isPlaying ? props.src : ''}
                    ref={iframeRef}></iframe>
            </div>

            <div className={`audioPlayerCard ${isPlaying ? 'active' : ''}`}>
                <button onClick={playPauseAudio}>
                    {!isPlaying &&
                        <i className="fa fa-play-circle" aria-hidden="true"></i>
                    }
                    {isPlaying &&
                        <i className="fa fa-pause-circle" aria-hidden="true"></i>
                    }
                </button>
                <div className='audioAttributes'>
                    <h5>Open</h5>
                </div>
            </div>
        </>
    )
}

export default IframeLoader;